import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  jobDescr: null,
};

export const jobDescrSlice = createSlice({
  name: "career",
  initialState,
  reducers: {
    updateJobDescr: (state, action) => {
      return {
        ...state,
        jobDescr: action.payload,
      };
    },
  },
});

export const { updateJobDescr } = jobDescrSlice.actions;

export default jobDescrSlice.reducer;
